import React, { useEffect, useState, useContext } from 'react'
import CIcon from '@coreui/icons-react'
import { cilBraille, cilPencil, cilUser } from '@coreui/icons'
import {
  CFormSwitch,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import { useHistory } from 'react-router-dom'
import SearchTable from 'src/components/searchTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown, faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from 'src/views/context/app'
import { ACCOUNT_API } from 'src/views/utils/urls'
import useAxios from 'axios-hooks'
import RoleplayModal from './roleplayModal'

const ManageAccounts = () => {
  const history = useHistory()
  const { setLoader } = useContext(AppContext)
  const [adminList, setAdminList] = useState([])
  const [roleplayAccountId, setRoleplayAccountId] = useState('')

  const [{ data: adminData, loading: adminDataLoading }, adminDataCall] = useAxios(
    {
      url: ACCOUNT_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: updateAdmin, loading: updateAdminLoading }, adminUpdateCall] = useAxios(
    {
      url: ACCOUNT_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    adminDataCall()
  }, [])

  useEffect(() => {
    if (adminData && adminData.success) {
      setAdminList(adminData.data.sort((ele1, ele2) => Number(ele2.status) - Number(ele1.status)))
    }
  }, [adminData])

  useEffect(() => {
    if (updateAdmin && updateAdmin.success) {
      adminDataCall()
    }
  }, [updateAdmin])

  useEffect(() => {
    setLoader(adminDataLoading || updateAdminLoading)
  }, [adminDataLoading, updateAdminLoading])

  const handleStatus = async (info) => {
    adminUpdateCall({
      params: {
        account_id: info._id,
      },
      data: { status: !info.status },
    })
  }
  const handleEdit = (info) => {
    history.push({ pathname: '/create-admin-accounts', state: info })
  }

  const handleTemplate = (info) => {
    history.push({ pathname: '/manage-templates', state: info })
  }

  const handleAdd = () => {
    history.push({ pathname: '/create-admin-accounts' })
  }

  const tableConfig = [
    {
      header: 'Account Name',
      dataCell: (info) => info.name,
      width: 20,
    },
    {
      header: 'Account Id',
      dataCell: (info) => info._id,
      width: 25,
    },
    {
      header: 'Contact Person',
      dataCell: (info) => info.contact_person,
      width: 15,
    },
    {
      header: 'Domain Name',
      dataCell: (info) => info.domain_name,
      width: 20,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 15,
    },
    {
      header: (
        <div className="flex justify-center">
          <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />
        </div>
      ),
      dataCell: (info) => (
        <CDropdown>
          <CDropdownToggle color="white" caret={false}>
            <FontAwesomeIcon icon={faEllipsisH} size="2x" />
          </CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem onClick={() => handleEdit(info)} className="cursor-pointer">
              <CIcon icon={cilPencil} style={{ color: 'black' }} size="sm" className="mr-2" />
              {'Edit'}
            </CDropdownItem>
            <CDropdownItem
              onClick={() => {
                setRoleplayAccountId(info._id)
              }}
              className="cursor-pointer"
            >
              <CIcon icon={cilUser} size="sm" className="mr-2" />
              {'Roleplay'}
            </CDropdownItem>
            <CDropdownItem onClick={() => handleTemplate(info)} className="cursor-pointer">
              <CIcon icon={cilBraille} size="sm" className="mr-2" />
              {'Templates'}
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      ),
      width: 5,
    },
  ]

  return (
    <>
      <h4>{`Manage Accounts`}</h4>
      <SearchTable
        type={`Admin Account`}
        tableCardHeight={70}
        disableButton={false}
        buttonName={`+ Create New Account`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={adminList}
        tableConfig={tableConfig}
        createPermission={true}
      />
      {roleplayAccountId && (
        <RoleplayModal accountId={roleplayAccountId} onClose={() => setRoleplayAccountId('')} />
      )}
    </>
  )
}

export default ManageAccounts
